import { useContext, useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/navbar/navbar";
import TierComponent from "../../components/TierComponent/TierComponent";
import { LoaderContext } from "../../context/LoaderContext";
import { AlertContext } from "../../context/AlertContext";
import { UserContext } from "../../context/UserContext";
import { Alert } from "../../utils/genericUtils";
import { useNavigate } from "react-router-dom";

import { ConfirmationModal } from "../../components/Modals/ConfirmationModal/confirmation-modal";

import "./change-plan.css";
import ArrowSvg from "../../assets/svg/arrowSvg";
import { PATCH } from "../../utils/httpUtils";
import { GetSubscriptionTier } from "../../utils/businessUtils.js";

export default function ChangePlanPage() {
  const router = useNavigate();

  const { showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);
  const { user, loginUser } = useContext(UserContext);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const selectedPlan = useRef(undefined);
  const [headerText, setHeaderText] = useState("");
  const [modalText, setModalText] = useState("");

  function GetModalHeader() {
    if (user.subscription > selectedPlan.current) {
      return "Downgrade Subscription?";
    } else {
      return "Upgrade Subscription?";
    }
  }

  function GetModalText() {
    if (user.subscription > selectedPlan.current) {
      return `Warning: Downgrading your plan will immediately remove access to exclusive features of your current plan. 
If your storage exceeds the limit of the new tier, files will be automatically moved to the Trash, starting with the most recently uploaded.`;
    } else {
      return "Awesome! You're upgrading your plan — enjoy more features and storage with FileFreak.io.";
    }
  }

  function OnTierSelect(tier) {
    selectedPlan.current = tier;
    setHeaderText(GetModalHeader());
    setModalText(GetModalText());

    setShowConfirmationModal(true);
  }

  async function OnConfirm() {
    showloader();
    let response = await PATCH("/change-subscription", { selectedPlan: selectedPlan.current }, user);
    hideloader();
    if (response.success) {
      //open checkout session if they did not previously have a customer id
      if (response.url) {
        //set jwt in local storage so the user does not lose their authenticated status for upgrading
        if (!localStorage.getItem("jwt")) localStorage.setItem("jwt", sessionStorage.getItem("jwt"));

        window.location.href = response.url;
        return;
      }

      Alert(
        globalAlert,
        "success",
        "Plan Upated Successfully!",
        `You account has been switched to the ${GetSubscriptionTier(
          selectedPlan.current
        )} plan. It might take a few minutes for your dashboard to reflect the changes.`,
        ToDashboard,
        "Back To Dashboard"
      );
    } else {
      if (response.error && response.error.message) {
        Alert(globalAlert, "error", "Something Went Wrong", response.error.message);
      } else {
        Alert(globalAlert, "error", "Something Went Wrong", "An unkown error occurred please try again later");
      }
    }
  }

  function OnCancel() {
    setShowConfirmationModal(false);
  }

  function ToDashboard() {
    router("/dashboard");
  }

  if (!user) return;

  return (
    <section className="change-plan-bg">
      <Navbar />

      {/* Confirmation Modal */}
      <ConfirmationModal
        id="change-plan-confirmation-modal"
        isActive={showConfirmationModal}
        header={headerText}
        message={modalText}
        animate={true}
        showDivider={true}
        onConfirm={OnConfirm}
        onDeny={OnCancel}
        confirmText={"Proceed"}
        confirmClass="btn-green"
        denyText="Cancel"
      />

      {/*PRICING INFORMATION*/}
      <section id="pricing-info">
        <h2 className="pricing-header">Which Plan Makes Sense For You or Your App?</h2>

        <section className="tiers-container">
          <TierComponent
            tierName="Basic"
            monthlyPrice="$4.99"
            tierHighlights={[
              {
                text: "Up to 250GB of Storage",
                isPositive: true,
              },
              {
                text: "Everything from Free Tier",

                isPositive: true,
              },
              {
                text: "Limited API access",
                isPositive: true,
              },
              {
                text: "Up to 1,000 API Requests/Daily",
                isPositive: true,
              },
              {
                text: "Great for Early App Development",
                isPositive: true,
              },
              {
                text: "Cancel Any Time!",
                isPositive: true,
              },
            ]}
            buttonText={user.subscription === 1 ? "Current" : "Select Plan"}
            disabled={user.subscription === 1}
            onClick={() => OnTierSelect(1)}
          />
          <TierComponent
            tierName="Plus"
            mostPopular={true}
            monthlyPrice="$9.99"
            tierHighlights={[
              {
                text: "Up to 500GB of Storage",
                isPositive: true,
              },
              {
                text: "Everything from Basic Tier",

                isPositive: true,
              },
              {
                text: "Improved API access",
                isPositive: true,
              },
              {
                text: "Up to 5,000 API Requests/Daily",
                isPositive: true,
              },
              {
                text: "Great for Small Applications",
                isPositive: true,
              },
              {
                text: "Additional Features Coming Soon",
                isPositive: true,
              },
              {
                text: "Cancel Any Time!",
                isPositive: true,
              },
            ]}
            buttonText={user.subscription === 2 ? "Current" : "Select Plan"}
            disabled={user.subscription === 2}
            onClick={() => OnTierSelect(2)}
          />
          <TierComponent
            tierName="Pro"
            monthlyPrice="$14.99"
            tierHighlights={[
              {
                text: "Up to 1TB of Storage",
                isPositive: true,
              },
              {
                text: "Everything from Plus Tier",

                isPositive: true,
              },
              {
                text: "Unlimited API access!",
                isPositive: true,
              },
              {
                text: "Great for Production Level Applications",
                isPositive: true,
              },
              {
                text: "Additional Features Coming Soon",
                isPositive: true,
              },
              {
                text: "Cancel Any Time!",
                isPositive: true,
              },
            ]}
            buttonText={user.subscription === 3 ? "Current" : "Select Plan"}
            disabled={user.subscription === 3}
            onClick={() => OnTierSelect(3)}
          />
        </section>

        {/* Go Back Button */}
        <button className="back-button standard-button change-plan-back-button" onClick={ToDashboard}>
          <ArrowSvg class={"svg"} />
          Back To Dashboard
        </button>


      </section>
      <Footer />
    </section>
  );
}
